module.exports = __webpack_public_path__ + "media/images/site/hamburguer-15fb581c43cbdd8f4783637549195c61.svg";